"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchListType = exports.MATCH_LIST_CATEGORY_RECORD_NAME = exports.RESET_MATCHES_CATEGORY = exports.GET_MISSING_MATCHES_FAIL = exports.GET_MISSING_MATCHES_SUCCESS = exports.GET_MISSING_MATCHES_REQUEST = exports.GET_FAVORITE_MATCHES_FAIL = exports.GET_FAVORITE_MATCHES_SUCCESS = exports.GET_FAVORITE_MATCHES_REQUEST = exports.GET_MATCHES_FAIL = exports.GET_MATCHES_SUCCESS = exports.GET_MATCHES_REQUEST = exports.NAME = void 0;
// TODO: rename 'matchList' to 'match-list' GINFE-1847
exports.NAME = 'matchList';
exports.GET_MATCHES_REQUEST = exports.NAME + "/GET_MATCHES:REQUEST";
exports.GET_MATCHES_SUCCESS = exports.NAME + "/GET_MATCHES:SUCCESS";
exports.GET_MATCHES_FAIL = exports.NAME + "/GET_MATCHES:FAIL";
exports.GET_FAVORITE_MATCHES_REQUEST = exports.NAME + "/GET_FAVORITE_MATCHES:REQUEST";
exports.GET_FAVORITE_MATCHES_SUCCESS = exports.NAME + "/GET_FAVORITE_MATCHES:SUCCESS";
exports.GET_FAVORITE_MATCHES_FAIL = exports.NAME + "/GET_FAVORITE_MATCHES:FAIL";
exports.GET_MISSING_MATCHES_REQUEST = exports.NAME + "/GET_MISSING_MATCHES:REQUEST";
exports.GET_MISSING_MATCHES_SUCCESS = exports.NAME + "/GET_MISSING_MATCHES:SUCCESS";
exports.GET_MISSING_MATCHES_FAIL = exports.NAME + "/GET_MISSING_MATCHES:FAIL";
exports.RESET_MATCHES_CATEGORY = exports.NAME + "/RESET_MATCHES_CATEGORY";
exports.MATCH_LIST_CATEGORY_RECORD_NAME = 'MatchListCategory';
var MatchListType;
(function (MatchListType) {
    MatchListType["UPCOMING"] = "upcoming";
    MatchListType["RESULTS"] = "results";
    MatchListType["OUTRIGHTS"] = "outrights";
})(MatchListType = exports.MatchListType || (exports.MatchListType = {}));
//# sourceMappingURL=constants.js.map